<div 
    class="agpr-dividerDisplay"
    [ngStyle]="{
        'background-color': data.styles.backgroundColor,
        'padding-top': data.styles.padding.paddingOption
                ? (data.styles.padding.topPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px',
        'padding-right': data.styles.padding.paddingOption
                ? (data.styles.padding.rightPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px',
        'padding-bottom': data.styles.padding.paddingOption
                ? (data.styles.padding.bottomPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px',
        'padding-left': data.styles.padding.paddingOption
                ? (data.styles.padding.leftPadding) + 'px'
                : (data.styles.padding.paddingAll) + 'px'
    }"
>
    <div
        [ngStyle]="{
            'display': 'block',
            'background-color': data.styles.dividerColor,
            'height': (data.styles.height) + 'px'
        }"
    ></div>
</div>